export default "__VITE_ASSET__CC6kPAm3__"